export default "__VITE_ASSET__CTsn$T3K__"